import React from "react";
import {ColumnsType} from "antd/es/table";
import {SuccessStatusSVG, SuccessSVG} from "assets";
import "./ModalTabPay.scss";

const columnModaTabPay: any = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "4%",
    align: "center",
  },
  {
    title: "Mã thuốc",
    dataIndex: "code",
    key: "code",
    width: "10%",
    // editable: true,
    align: "left",
  },
  {
    title: "Tên thuốc",
    dataIndex: "name",
    key: "name",
    width: "10%",
    // editable: true,
    align: "left",
  },
  {
    title: "DV tính",
    dataIndex: "dv",
    key: "dv",
    width: "8%",
    // editable: true,
    align: "left",
  },
  {
    title: "SL",
    dataIndex: "sl",
    key: "tl/tt",
    width: "4%",
    // editable: true,
    align: "right",
  },
  {
    title: "Đơn giá",
    dataIndex: "price",
    key: "price",
    width: "10%",
    // editable: true,
    align: "right",
  },
  {
    title: "Loại SP",
    dataIndex: "type",
    key: "type",
    width: "10%",
    // editable: true,
    align: "left",
  },
  {
    title: "SL thực",
    dataIndex: "slReal",
    key: "slReal",
    width: "4%",
    // editable: true,
    align: "right",
  },
  {
    title: "VAT",
    dataIndex: "vat",
    key: "vat",
    width: "10%",
    // editable: true,
    align: "right",
  },
  {
    title: "Thành tiền",
    dataIndex: "money",
    key: "money",
    width: "10%",
    // editable: true,
    align: "right",
  },
  {
    title: "Liều dùng",
    dataIndex: "number",
    key: "number",
    width: "10%",
    // editable: true,
    align: "left",
  },
  {
    title: "Ghi chú",
    dataIndex: "note",
    key: "note",
    width: "10%",
    // editable: true,
    align: "left",
  },
];

export {columnModaTabPay};
